import { useQuery } from "@tanstack/react-query";

import {
  getGetPaymentsPaymentsGetQueryKey,
  getPaymentsPaymentsGet,
} from "@/api-v3";

export function useGetFirstPagePayments() {
  const params = { page: 1 };

  const {
    data: payments,
    isFetching: isPaymentsLoading,
    isError: hasPaymentsErrored,
    refetch: refetchPayments,
  } = useQuery({
    queryKey: getGetPaymentsPaymentsGetQueryKey(params),
    queryFn: ({ signal }) => getPaymentsPaymentsGet(params, undefined, signal),
    select: (data) => data.data,
    refetchOnMount: "always",
    refetchOnWindowFocus: "always",
  });

  return {
    payments,
    isPaymentsLoading,
    hasPaymentsErrored,
    refetchPayments,
  };
}
